import * as components from './components';

export default { components };



// WEBPACK FOOTER //
// ./src/modules/core/index.js